<app-header></app-header>
<div class="container-fluid main">

 <router-outlet></router-outlet>
</div>









